{
    "name": "frog-client",
    "version": "1.0.0",
    "scripts": {
        "ng": "ng",
        "start": "ng serve",
        "hosted": "ng serve -c hosted-dev",
        "build": "ng build",
        "test": "ng test",
        "e2e": "ng e2e",
        "playground": "angular-playground",
        "lint": "eslint ./src/app --ext .ts",
        "lint:fix": "eslint ./src/app --ext .ts --fix",
        "format": "prettier --write .",
        "sentry:sourcemaps": "sentry-cli sourcemaps inject --org ubd --project frog-client ./dist && sentry-cli sourcemaps upload --org ubd --project frog-client ./dist"
    },
    "private": true,
    "dependencies": {
        "@angular/animations": "20.3.0",
        "@angular/cdk": "20.2.3",
        "@angular/common": "20.3.0",
        "@angular/compiler": "20.3.0",
        "@angular/core": "20.3.0",
        "@angular/forms": "20.3.0",
        "@angular/material": "20.2.3",
        "@angular/platform-browser": "20.3.0",
        "@angular/platform-browser-dynamic": "20.3.0",
        "@angular/router": "20.3.0",
        "@angular/service-worker": "20.3.0",
        "@auth0/auth0-angular": "^2.2.2",
        "@sentry/angular": "^10.19.0",
        "@sentry/cli": "^2.56.1",
        "@sentry/tracing": "^7.94.1",
        "@stripe/stripe-js": "^7.9.0",
        "@types/video.js": "^7.3.26",
        "cropperjs": "^1.5.9",
        "fabric": "^6.7.1",
        "konva": "9.3.22",
        "marked": "^9.1.4",
        "ng-recaptcha-2": "^16.0.1",
        "ng2-konva": "10.0.0-0",
        "ngx-scrollbar": "^13.0.3",
        "ngx-stripe": "^20.7.0",
        "perfect-freehand": "^1.2.2",
        "prosemirror-example-setup": "1.2.2",
        "prosemirror-markdown": "1.11.0",
        "prosemirror-model": "1.19.3",
        "prosemirror-schema-list": "1.3.0",
        "prosemirror-state": "1.4.3",
        "prosemirror-view": "1.32.3",
        "rxjs": "^7.5.6",
        "tslib": "^2.0.0",
        "video.js": "^7.14.3",
        "zone.js": "~0.15.1"
    },
    "devDependencies": {
        "@angular-builders/custom-webpack": "20.0.0",
        "@angular-devkit/build-angular": "20.3.1",
        "@angular-eslint/template-parser": "^20.2.0",
        "@angular/cli": "20.3.1",
        "@angular/compiler-cli": "20.3.0",
        "@sentry/webpack-plugin": "2.2.0",
        "@types/d3": "7.1.0",
        "@types/jasmine": "~3.6.0",
        "@types/jasminewd2": "~2.0.3",
        "@types/node": "^24.3.1",
        "@typescript-eslint/eslint-plugin": "^8.43.0",
        "@typescript-eslint/parser": "^8.43.0",
        "angular-eslint": "20.2.0",
        "baseline-browser-mapping": "^2.9.7",
        "codelyzer": "^6.0.0",
        "eslint": "^9.35.0",
        "eslint-config-prettier": "^10.1.8",
        "eslint-plugin-prettier": "^5.5.4",
        "jasmine-core": "~3.6.0",
        "jasmine-spec-reporter": "~5.0.0",
        "karma": "6.4.4",
        "karma-chrome-launcher": "~3.1.0",
        "karma-coverage-istanbul-reporter": "~3.0.2",
        "karma-jasmine": "~4.0.0",
        "karma-jasmine-html-reporter": "^1.5.0",
        "prettier": "^3.6.2",
        "protractor": "~7.0.0",
        "ts-node": "~8.3.0",
        "tslint": "~6.1.0",
        "typescript": "5.9.2",
        "typescript-eslint": "8.40.0"
    }
}
